module.exports = __webpack_public_path__ + "static/media/ADC1.15fbf93c.svg";